"use client"

import { ReactNode } from "react"

// This is now a simpler UI component that takes an onClick handler and children
interface MobileCategoriesButtonProps {
  onClick: () => void
  children: ReactNode
}

export const MobileCategoriesButton = ({ onClick, children }: MobileCategoriesButtonProps) => {
  return (
    <button type="button" onClick={onClick} className="flex items-center justify-center lg:hidden">
      {children}
    </button>
  )
}
